import { compose, find, prop, propEq } from 'ramda';
import { createSelector } from 'reselect';

import { NAME } from './constants';

const getRoot = prop(NAME);

export const getQuickFilterState = compose(prop('quickFilter'), getRoot);
export const getSelectedContactIds = compose(prop('selectedContactIds'), getRoot);
export const getContacts = compose(prop('contacts'), getRoot);
export const getSort = compose(prop('sort'), getRoot);
export const getResetRelatedSections = compose(prop('resetRelatedSections'), getRoot);

export const getSelectedContactType = createSelector(
	getSelectedContactIds,
	getContacts,
	(selectedContactIds, contacts) =>
		selectedContactIds.map((id) => find(propEq(id, 'id'))(contacts)).map((contact) => contact.solutionStateId),
);
